import { render } from "./CompanyRegistration.vue?vue&type=template&id=02fedf40&scoped=true"
import script from "./CompanyRegistration.vue?vue&type=script&lang=js"
export * from "./CompanyRegistration.vue?vue&type=script&lang=js"

import "./custom-company-registration.scss?vue&type=style&index=0&id=02fedf40&lang=scss&scoped=true"
import "./CompanyRegistration.vue?vue&type=style&index=1&id=02fedf40&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02fedf40"]])

export default __exports__